/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-03-18 14:12:50
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-12-15 15:03:38
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\api\userinfo.js
 */
//用户信息模块  用户角色关联表

//引入接口文档
import req from '@/utils/req.js'


//用户列表信息获取
export function api_getuserinfo(params) {
    return req.get("/admin/user-info/page", params);
}

//获取用户当前所有角色
export function api_getuserresoce(id) {
    return req.get(`/admin/user-role/${id}`);
}

//分配角色按钮获取当前用户拥有角色
export function api_ge_tuser_resoce_list(params) {
    return req.get('/admin/user-role/user-id',params);
}

//给用户批量添加角色
export function api_adduserinforesoce(params) {
    return req.post("/admin/user-role/add-list", params);
}


//创建用户
export function api_create_user(params) {
    return req.post("/admin/user/create", params);
}
//获取录入权限医院科室
export function getOcrSaveList(params) {
    return req.post("/admin/ocr-permission/ocrSaveList", params);
}

//查看医院科室
export function getPermissionList(params) {
    return req.post("/admin/ocr-permission/list", params);
}

//用户启用接口
export function api_on_enabeld(params) {
    return req.put("/admin/user/enabled", params);
}
//修改用户ocr 权限
export function put_permission(params) {
    return req.put("/admin/ocr-permission", params);
}

//用户停用接口
export function api_off_enabeld(params) {
    return req.put("/admin/user/disabled", params);
}

//用户删除接口
export function api_del_user(id) {
    return req.delete(`/admin/user/${id}`);
}

//用户信息更新
export function api_update_userinfo(params) {
    return req.put("/admin/user-info", params);
}   


//重置用户密码
export function api_reset_pwd(userId) {
    return req.put(`/admin/user/reset/password/${userId}`);
}
//判断当前用户是否需要签名
export function isNeedSign(params) {
    return req.get("/doctor/doctor/isNeedSign", params);
}